import { render, staticRenderFns } from "./create-umfrage-modal.vue?vue&type=template&id=631a2c1d&scoped=true"
import script from "./create-umfrage-modal.vue?vue&type=script&lang=js"
export * from "./create-umfrage-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631a2c1d",
  null
  
)

export default component.exports